import React from "react";
import { Link } from "react-router-dom";

const PROJECT_ORDER = [
  { slug: "crm", to: "/project/crm", name: "Maxis CRM" },
  { slug: "familytree", to: "/project/family-tree", name: "FamilyTree" },
  { slug: "exchange", to: "/project/coin-exchange", name: "CoinExchange" },
  { slug: "vcx", to: "/project/vcx", name: "VCX" },
  { slug: "nft", to: "/project/nft", name: "MLB NFT" },
  { slug: "terapool", to: "/project/terapool", name: "Terapool" },
];

function ArrowLeft() {
  return (
    <svg width="30" height="10" viewBox="0 0 30 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M29 5H1M1 5L8 1M1 5L8 9"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ArrowRight() {
  return (
    <svg width="30" height="10" viewBox="0 0 30 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 5H29M22 1L29 5M22 9L29 5"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function ProjectNav({ current }) {
  const index = PROJECT_ORDER.findIndex((p) => p.slug === current);
  const prev = index > 0 ? PROJECT_ORDER[index - 1] : null;
  const next = index < PROJECT_ORDER.length - 1 ? PROJECT_ORDER[index + 1] : null;

  if (!prev && !next) return null;

  return (
    <div className="project-nav flex g-32 xs:g-20">
      {prev && (
        <Link to={prev.to} className="project-nav-link prev" title={prev.name}>
          <span className="project-nav-label">Previous</span>
          <ArrowLeft />
        </Link>
      )}
      {next && (
        <Link to={next.to} className="project-nav-link next" title={next.name}>
          <span className="project-nav-label">Next</span>
          <ArrowRight />
        </Link>
      )}
    </div>
  );
}
